export const PASSWORD_RESET = 'sign-in-page/PASSWORD_RESET';
export const PASSWORD_RESET_SUCCESS = 'sign-in-page/PASSWORD_RESET_SUCCESS';
export const PASSWORD_RESET_FAIL = 'sign-in-page/PASSWORD_RESET_FAIL';
